export default "__VITE_ASSET__Dgu$PRZt__"